import React from "react";
import { HomeMainViewTemplate } from "themes/application/home/components";

function HomeMainView(props) {
    return <HomeMainViewTemplate {...props} />;
}

export default HomeMainView;
